// import jQuery from 'CommonScripts/jquery-1.10.2';

var qVariable;
(function (window, document, $) {
    var questionnarieDiv;

    window.buyProduct = function(url, productId, useJoomlaCheckout) {

        if (url !== "" && productId !== "" && useJoomlaCheckout !== "") {
            //console.log("buyProduct", url, productId, useJoomlaCheckout);

            var addbasketurlJoomla = "/component/configurator/?task=addItemToBasket";
            var addbasketurlSitecoreApi = "/api/sitecore/checkout/addproducts";

            var urlshop = url +
            (useJoomlaCheckout === "True"
                ? addbasketurlJoomla
                : addbasketurlSitecoreApi);

            var productsinfo = {};
            var product1 = {
                productid: productId
            }
            productsinfo.product1 = product1;

            $('body').find('form').attr('method', 'POST')
                .attr('action', urlshop)
                .attr('target', '_blank');


            if (useJoomlaCheckout === "False") {
                //used for Sitecore Site
                window.open(urlshop + "?id=" + productId);

            } else {
                //used for Joomla Site
                var productsinfoHiddenField = $('<input type="hidden" name="productsinfo" id="productsinfo" />')
                    .val(JSON.stringify(productsinfo));

                $('form').append(productsinfoHiddenField);
                $('form').submit();
                productsinfoHiddenField.remove();
            }
        }
    };


    $(document).ready(function () {
        questionnarieDiv = $(".questionnarieClass");
        if (questionnarieDiv.length > 0) {
            hideAllSteps();
        }
    });

    var hideAllSteps = function() {
        $(".steps").hide();
    };

})(window, document, jQuery);

window.showHideStep = function (divId) {

    jQuery(".steps").hide();
    jQuery(".startClass").hide();

    if (jQuery("#questionnarieDiv #" + divId + "").length > 0) {
        jQuery("#questionnarieDiv").css("display", "block");
    } else {
        jQuery("#questionnarieDiv").css("display", "none");
    }


    var currentQuestion = jQuery("#" + divId + "");

    currentQuestion.show();

    var divActiveCompatibilitySpot1 = currentQuestion.find(".activeCompatibilitySpot ");

    if (divActiveCompatibilitySpot1.length > 0) {
        divActiveCompatibilitySpot1.find("#divResult").hide();
        divActiveCompatibilitySpot1.find("#productTypeSelector").show();
        var ddlCmbWindowType = divActiveCompatibilitySpot1.find('.classCmbWindowType');
        if (ddlCmbWindowType.length > 0) {
            ddlCmbWindowType.val("").trigger('change');
        }
    }
};